export enum ReferenciaConta {
    'pedido' = 'pedido',
    'manual' = 'manual'
}